import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { featureFlagActions } from '../actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/effects";
export class WebAngularSharedDataAccessFeatureFlagApiEffects {
    constructor(featureFlagActions$) {
        this.featureFlagActions$ = featureFlagActions$;
        this.projectSpecificInitializationComplete = false;
        this.initializationComplete$ = createEffect(() => this.featureFlagActions$.pipe(ofType(featureFlagActions.ActionTypes.SET_FLAGS), map(() => {
            this.projectSpecificInitializationComplete = true;
            return new featureFlagActions.InitalizationCompleteAction(this.projectSpecificInitializationComplete);
        })));
    }
    static { this.ɵfac = function WebAngularSharedDataAccessFeatureFlagApiEffects_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || WebAngularSharedDataAccessFeatureFlagApiEffects)(i0.ɵɵinject(i1.Actions)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WebAngularSharedDataAccessFeatureFlagApiEffects, factory: WebAngularSharedDataAccessFeatureFlagApiEffects.ɵfac }); }
}
//# sourceMappingURL=feature-flag.effects.js.map